type PropTypes = {
  className?: string
}

const UserIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 18"
      className={className}
    >
      <path
        fill="currentColor"
        d="M15.883 16.424h-1.06v-2.647a2.65 2.65 0 0 0-2.646-2.647v-1.059a3.71 3.71 0 0 1 3.706 3.706v2.647ZM11.647 16.424h-1.059v-2.647a2.65 2.65 0 0 0-2.647-2.647H4.764a2.65 2.65 0 0 0-2.647 2.647v2.647H1.06v-2.647a3.71 3.71 0 0 1 3.705-3.706h3.177a3.71 3.71 0 0 1 3.706 3.706v2.647ZM10.588 1.6v1.06a2.647 2.647 0 0 1 0 5.294v1.058a3.706 3.706 0 1 0 0-7.411ZM6.353 2.66a2.647 2.647 0 1 1 0 5.294 2.647 2.647 0 0 1 0-5.295Zm0-1.06a3.706 3.706 0 1 0 0 7.412 3.706 3.706 0 0 0 0-7.411Z"
      />
    </svg>
  )
}

export default UserIcon
